export const Props = () => ({
  //Основной цвет
  colorMain: { 
    type: String,
    default: "var(--audio-volume-icon-primary)",
  },

  //Второстепенный цвет
  colorSecondary:{
    type: String,
    default: "var(--audio-volume-icon-secondary)",
  },

  //Размер иконки
  size: {
    type: Number,
    default: 18,
  }
});